import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiRequestService, LogService, UseCase } from '@prekog/common-ui';
import { Observable } from 'rxjs';

import { STORE_BACKEND_URL } from 'src/app/app.config';
import { FestivalStatisticTotals } from '../../shared/models/festival-statistic-totals.model';
import { GetFestivalStatisticTotalsRequest } from './get-festival-statistic-totals.request';

@Injectable({
    providedIn: 'root'
})
export class LoadFestivalGlobalTotalsUseCase extends UseCase<GetFestivalStatisticTotalsRequest, Observable<FestivalStatisticTotals>> {
    private _apiRequestService = inject(ApiRequestService);
    private _storeBaseUrl = inject<string>(STORE_BACKEND_URL);

    constructor(_logService: LogService, _http: HttpClient) {
        super(_logService, _http);
    }

    protected override executeBusinessLogic(request: GetFestivalStatisticTotalsRequest | void): Observable<FestivalStatisticTotals> | void {
        return this._apiRequestService.sendRequest<GetFestivalStatisticTotalsRequest, FestivalStatisticTotals>(
            this._storeBaseUrl,
            request as GetFestivalStatisticTotalsRequest,
            true,
            '/admin/getTotalFestivalStatistics'
        );
    }
}
